// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  app: "",
  baseUrl: "",
  socketUrl: "",
  device: "",
  isRole: "",
  isRent: false,
  isParty: false,
  socket: null,
  modalPopup: null,
  toastPopup: null,
  title: "",
  role: {
    SUPER_ADMIN: "SUPER_ADMIN",
    ADMIN: "ADMIN",
    SUPER_MASTER: "SUPER_MASTER",
    MASTER: "MASTER",
    OPERATOR: "OPERATOR",
    USER: "USER",
  },
  TRANS: {
    CREDIT: "CREDIT",
    DEBIT: "DEBIT",
  },
  theme: {
    darkTheme: "darkTheme",
    lightTheme: "lightTheme",
  },
  event: {
    OPEN: "OPEN",
    CLOSE: "CLOSE",
  },
  host: null,
  hosts: [
    {
      domain: "localhost",
      name: "localhost",
      ext: ".com",
      meta: {
        name: "theme-color",
        content: "#000",
      },
      lightTheme:
        ":root {--theme-sucess: #4caf50;--theme-danger: #f00;--result-color: #d1780c;--theme-white: #000;--theme-light: #abb4be;--theme-grey: #e4e4e4;--theme-orange: #FF6C23;--theme-black: #cfcfcf;--theme-mid-black: #f2f2f2;--theme-carbon-black: #fff;--theme_bg_color: #016ba0;--theme-black-default: #000;--theme-gredint-bg: linear-gradient(210deg, rgba(0,94,254,1) 0%, rgba(112,59,239,1) 100%);--themetext-shadow: 1px 1px 2px rgb(104, 104, 104);}",
      darkTheme:
        ":root {--theme-sucess: #4caf50;--theme-danger: #f00;--result-color: #d1780c;--theme-white: #fff;--theme-light: #abb4be;--theme-grey: #e4e4e4;--theme-orange: #FF6C23;--theme-black: #000;--theme-mid-black: #2E353E;--theme-carbon-black: #1D2127;--theme_bg_color: #016ba0;--theme-gredint-bg: linear-gradient(210deg, rgba(0,94,254,1) 0%, rgba(112,59,239,1) 100%);--themetext-shadow: 1px 1px 2px rgb(104, 104, 104);}",
      email: "",
      baseUrl: "http://localhost:1000",
      socketUrl: "http://localhost:1000",
      // baseUrl: "https://sadmin.digitalmatka.com",
      // socketUrl: "https://sadmin.digitalmatka.com",
    },
    {
      domain: "sadmin.goalottery.info",
      name: "sadmin.goalottery",
      ext: ".online",
      meta: {
        name: "theme-color",
        content: "#000",
      },
      lightTheme:
        ":root {--theme-sucess: #4caf50;--theme-danger: #f00;--result-color: #d1780c;--theme-white: #000;--theme-light: #abb4be;--theme-grey: #e4e4e4;--theme-orange: #FF6C23;--theme-black: #cfcfcf;--theme-mid-black: #f2f2f2;--theme-carbon-black: #fff;--theme_bg_color: #016ba0;--theme-black-default: #000;--theme-gredint-bg: linear-gradient(210deg, rgba(0,94,254,1) 0%, rgba(112,59,239,1) 100%);--themetext-shadow: 1px 1px 2px rgb(104, 104, 104);}",
      darkTheme:
        ":root {--theme-sucess: #4caf50;--theme-danger: #f00;--result-color: #d1780c;--theme-white: #fff;--theme-light: #abb4be;--theme-grey: #e4e4e4;--theme-orange: #FF6C23;--theme-black: #000;--theme-mid-black: #2E353E;--theme-carbon-black: #1D2127;--theme_bg_color: #016ba0;--theme-gredint-bg: linear-gradient(210deg, rgba(0,94,254,1) 0%, rgba(112,59,239,1) 100%);--themetext-shadow: 1px 1px 2px rgb(104, 104, 104);}",
      email: "",
      baseUrl: "https://sadmin.goalottery.info",
      socketUrl: "https://sadmin.goalottery.info",
    },
    {
      domain: "sadmin.digitalmatka.com",
      name: "sadmin.digitalmatka",
      ext: ".online",
      meta: {
        name: "theme-color",
        content: "#000",
      },
      lightTheme:
        ":root {--theme-sucess: #4caf50;--theme-danger: #f00;--result-color: #d1780c;--theme-white: #000;--theme-light: #abb4be;--theme-grey: #e4e4e4;--theme-orange: #FF6C23;--theme-black: #cfcfcf;--theme-mid-black: #f2f2f2;--theme-carbon-black: #fff;--theme_bg_color: #016ba0;--theme-black-default: #000;--theme-gredint-bg: linear-gradient(210deg, rgba(0,94,254,1) 0%, rgba(112,59,239,1) 100%);--themetext-shadow: 1px 1px 2px rgb(104, 104, 104);}",
      darkTheme:
        ":root {--theme-sucess: #4caf50;--theme-danger: #f00;--result-color: #d1780c;--theme-white: #fff;--theme-light: #abb4be;--theme-grey: #e4e4e4;--theme-orange: #FF6C23;--theme-black: #000;--theme-mid-black: #2E353E;--theme-carbon-black: #1D2127;--theme_bg_color: #016ba0;--theme-gredint-bg: linear-gradient(210deg, rgba(0,94,254,1) 0%, rgba(112,59,239,1) 100%);--themetext-shadow: 1px 1px 2px rgb(104, 104, 104);}",
      email: "",
      baseUrl: "https://sadmin.digitalmatka.com",
      socketUrl: "https://sadmin.digitalmatka.com",
    },
  ],
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
